define.alias("shared/components/shared/post/sandbox", "media/components/shared/post/sandbox");